import { Routes } from '@angular/router'

export const MAIN_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'news/all',
    },
    {
        path: 'news',
        pathMatch: 'full',
        redirectTo: 'news/all',
    },
    {
        path: 'news/all',
        pathMatch: 'full',
        title: 'Новости',
        loadComponent: () =>
            import('../pages/news/news.component').then((c) => c.NewsComponent),
    },
    {
        path: 'news/announcement',
        pathMatch: 'full',
        title: 'Объявления',
        loadComponent: () =>
            import('../pages/announcement/announcement.component').then(
                (c) => c.AnnouncementComponent
            ),
    },
    {
        path: 'event-calendar',
        pathMatch: 'full',
        title: 'Календарь событии',
        loadComponent: () =>
            import('../pages/event-calendar/event-calendar.component').then(
                (c) => c.EventCalendarComponent
            ),
    },
    {
        path: 'event-calendar/detail/:id',
        title: 'Календарь событии',
        loadComponent: () =>
            import(
                '../pages/event-calendar-detail/event-calendar-detail.component'
            ).then((c) => c.EventCalendarDetailComponent),
    },
    {
        path: 'teams',
        pathMatch: 'full',
        title: 'Команды',
        loadComponent: () =>
            import('../pages/teams/teams.component').then(
                (c) => c.TeamsComponent
            ),
    },
        {
        path: 'seasons',
        pathMatch: 'full',
        title: 'Сезоны',
        loadComponent: () =>
            import('../pages/seasons/seasons.component').then(
                (c) => c.SeasonsComponent
            ),
    },
    {
        path: 'ratings',
        pathMatch: 'full',
        title: 'Рейтинг',
        loadComponent: () =>
            import('../pages/ratings/ratings.component').then(
                (c) => c.RatingsComponent
            ),
    },
    {
        path: 'general-points',
        pathMatch: 'full',
        title: 'Общие очки',
        loadComponent: () =>
            import('../pages/general-points/general-points.component').then(
                (c) => c.GeneralPointsComponent
            ),
    },
    {
        path: 'promotion',
        pathMatch: 'full',
        title: 'Модерация',
        loadComponent: () =>
            import(`../pages/promotion/promotion.component`).then(
                (c) => c.PromotionComponent
            ),
    },
    {
        path: 'category',
        pathMatch: 'full',
        title: 'Категории',
        loadComponent: () =>
            import('../pages/category/category.component').then(
                (c) => c.CategoryComponent
            ),
    },
    {
        path: 'places',
        pathMatch: 'full',
        title: 'Заведения',
        loadComponent: () =>
            import('../pages/place/place.component').then(
                (c) => c.PlaceComponent
            ),
    },
    {
        path: 'places/detail/:id',
        pathMatch: 'full',
        title: 'Заведение',
        loadComponent: () =>
            import('../pages/place/place-detail/place-detail.component').then(
                (c) => c.PlaceDetailComponent
            ),
    },
    {
        path: 'dictionary',
        pathMatch: 'full',
        redirectTo: 'dictionary/company',
    },

    {
        path: 'dictionary/company',
        pathMatch: 'full',
        title: 'Компания',
        loadComponent: () =>
            import('../pages/company/company.component').then(
                (c) => c.CompanyComponent
            ),
    },

    {
        path: 'dictionary/city',
        pathMatch: 'full',
        title: 'Города',
        loadComponent: () =>
            import('../pages/city/city.component').then((c) => c.CityComponent),
    },

    {
        path: 'dictionary/languages',
        pathMatch: 'full',
        title: 'Языки',
        loadComponent: () =>
            import('../pages/language-types/language-types.component').then(
                (c) => c.LanguageTypesComponent
            ),
    },

    {
        path: 'dictionary/colors',
        pathMatch: 'full',
        title: 'Цвета',
        loadComponent: () =>
            import('../pages/colors-type/colors-type.component').then(
                (c) => c.ColorsTypeComponent
            ),
    },

    {
        path: 'dictionary/news',
        pathMatch: 'full',
        title: 'Тип новостей',
        loadComponent: () =>
            import('../pages/news-types/news-types.component').then(
                (c) => c.NewsTypesComponent
            ),
    },

    {
        path: 'dictionary/notifications',
        pathMatch: 'full',
        title: 'Тип уведомлений',
        loadComponent: () =>
            import(
                '../pages/notification-types/notification-types.component'
            ).then((c) => c.NotificationTypesComponent),
    },

    {
        path: 'users',
        pathMatch: 'full',
        redirectTo: 'users/partners',
    },

    {
        path: 'users/partners',
        pathMatch: 'full',
        title: 'Партнеры',
        loadComponent: () =>
            import('../pages/partners/partners.component').then(
                (c) => c.PartnersComponent
            ),
    },

    {
        path: 'users/partners/partner-registration-status',
        pathMatch: 'full',
        title: 'Заявка на регистрацию',
        loadComponent: () =>
            import(
                '../pages/partners/partner-registration-status/partner-registration-status.component'
            ).then((c) => c.PartnerRegistrationStatusComponent),
    },

    {
        path: 'users/partners/partner-detail',
        pathMatch: 'full',
        title: 'Заявка на регистрацию',
        loadComponent: () =>
            import(
                '../pages/partners/partner-detail/partner-detail.component'
            ).then((c) => c.PartnerDetailComponent),
    },

    {
        path: 'users/employees',
        pathMatch: 'full',
        title: 'Сотрудники',
        loadComponent: () =>
            import('../pages/employees/employees.component').then(
                (c) => c.EmployeesComponent
            ),
    },

    {
        path: 'support',
        redirectTo: 'support/all',
    },
    {
        path: 'support/all',
        pathMatch: 'full',
        title: 'Все обращения',
        loadComponent: () =>
            import('../pages/support/support.component').then(
                (c) => c.SupportComponent
            ),
    },

    {
        path: 'support/review',
        pathMatch: 'full',
        title: 'Отзывы',
        loadComponent: () =>
            import('../pages/review/review.component').then(
                (c) => c.ReviewComponent
            ),
    },

    {
        path: 'settings',
        redirectTo: 'settings/version',
    },

    {
        path: 'settings/version',
        pathMatch: 'full',
        title: 'Версия',
        loadComponent: () =>
            import('../pages/settings/version/version.component').then(
                (c) => c.VersionComponent
            ),
    },

    {
        path: 'support/ideas',
        pathMatch: 'full',
        title: 'Идеи и предложения',
        loadComponent: () =>
            import('../pages/ideas/ideas.component').then(
                (c) => c.IdeasComponent
            ),
    },

    // {
    //     path: 'profile',
    //     pathMatch: 'full',
    //     title: 'Пользователь',
    //     loadComponent: () =>
    //         import('../pages/profile/profile.component').then(
    //             (c) => c.ProfileComponent
    //         ),
    // },
]
